import { combineReducers } from 'redux';
import {
    SET_SELECTED_EMPLOYEE,

    GET_EMPLOYEES_LOADING,
    GET_EMPLOYEES_SUCCESS,
    GET_EMPLOYEES_ERROR,

} from './actions'

const selectedEmployee = (state, action) => {
    if (typeof state === 'undefined') {
        return {}
    }
    switch (action.type) {
        case SET_SELECTED_EMPLOYEE: {
            return action.data
        }
        default:
            return state
    }
};

const initialState = {
    loading: false, data: {}, error: ""
}

const employees = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }
    switch (action.type) {
        case GET_EMPLOYEES_LOADING: {
            return {
                loading: true,
                data: {},
                error: ""
            }
        }
        case GET_EMPLOYEES_SUCCESS: {
            return {
                loading: false,
                data: action.data,
                error: ""
            }
        }
        case GET_EMPLOYEES_ERROR: {
            return {
                loading: false,
                data: {},
                error: action.errorMessage
            }
        }
        default:
            return state
    }
};

export default combineReducers({
    selectedEmployee,
    employees
});